import { useEffect, useRef, useState } from 'react';

import useUploadsInFlight from './useUploadsInFlight';
import { uploadOutcomeChannel } from '../../domain/services/upload/upload.outcome.channel';

const refusalListener = ({ latest, unwarnedRefusal, setWaiting }) => (outcome) => {
    if (!outcome || !outcome.refused) return;
    if (!latest.current.waiting) {
        unwarnedRefusal.current = true;
        return;
    }
    setWaiting(false);
    latest.current.onRefused();
};

export default function useFinishAfterUploads({ requestId, onFinish, onRefused }) {
    const { inFlight, count } = useUploadsInFlight();
    const [waiting, setWaiting] = useState(false);
    const unwarnedRefusal = useRef(false);
    const latest = useRef({ onFinish, onRefused, waiting });
    latest.current = { onFinish, onRefused, waiting };

    useEffect(() => {
        if (!waiting || inFlight) return undefined;
        const afterOutcomes = setTimeout(() => {
            setWaiting(false);
            latest.current.onFinish();
        });
        return () => clearTimeout(afterOutcomes);
    }, [waiting, inFlight]);

    useEffect(() => (requestId
        ? uploadOutcomeChannel.listen(requestId, refusalListener({ latest, unwarnedRefusal, setWaiting }))
        : undefined), [requestId]);

    const requestFinish = () => {
        if (unwarnedRefusal.current) {
            unwarnedRefusal.current = false;
            return onRefused();
        }
        if (inFlight) return setWaiting(true);
        return onFinish();
    };

    return { waiting, remaining: count, requestFinish };
}
